import React, { useState, useEffect } from 'react';
import alanBtn from '@alan-ai/alan-sdk-web';
import wordsToNumbers from 'words-to-numbers';
import NewsCards from './components/NewsCards/NewsCards';

const alanKey = 'd88d0bf3f3730c4f35f9ac7a65646fc72e956eca572e1d8b807a3e2338fdd0dc/stage';

const App = () => {
    const [newsArticles, setNewsArticles] = useState([]);
    const [activeArticle, setActiveArticle] = useState(-1);

    useEffect(() => {
        alanBtn({
            key: alanKey,
            onCommand: ({ command, articles, number }) => {
                if (command === 'newHeadlines') {
                    setNewsArticles(articles);
                    setActiveArticle(-1);
                } else if (command === 'highlight') {
                    setActiveArticle((prevActiveArticle) => prevActiveArticle + 1);
                } else if (command === 'open') {
                    const parsedNumber = number.length > 2 ? wordsToNumbers(number, { fuzzy: true }) : null
                    const grabbedArticleNumber = [parsedNumber - 1];
                    // console.log(grabbedArticleNumber);
                    // window.open(articles[grabbedArticleNumber].url, '_blank');
                    // console.log(articles[grabbedArticleNumber].title);
                    console.log(articles[grabbedArticleNumber].url);
                    window.open(articles[grabbedArticleNumber].url, '_blank');
                }
            }
        })
    }, [])

    return (
        <div className='greetingForLucy'>
            <h1 className='newsSourceTop'>Lucinda news:</h1>
            <NewsCards articles={newsArticles} activeArticle={activeArticle} />
            <h1 className='newsSourceBottom'>Lucinda news:</h1>
            <div className='devLink'>
                <a
                    className="App-link"
                    href="https://github.com/Hacking-NASSA-with-HTML/alan_ai_news_app"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Give it a Star on github
                </a>
            </div>
        </div>
    )
}

export default App